export default __webpack_public_path__ + "static/banner-community-32a62f13644fb857ff84935a101261b9.webp";